import React, { memo } from 'react';
import telegramPreview from '@Theme/icons/telegram-mobile.png';

function TelegramPreview({ variation }) {
  return (
    <div style={{ display: 'flex', position: 'relative' }}>
      <img src={telegramPreview} />
      <div
        className="sms-preview-body telegram"
        style={{
          position: 'absolute',
          left: 30,
          top: 100,
          width: '100%',
          maxWidth: 'calc(100% - 60px)',
        }}
      >
        <div
          className="sms-preview-message telegram-msg"
          style={{ textAlign: 'left' }}
        >
          {variation && variation.message ? (
            <div
              style={{ margin: 0 }}
              dangerouslySetInnerHTML={{
                __html: variation.message,
              }}
            ></div>
          ) : (
            <span>Your text here</span>
          )}
        </div>
      </div>
    </div>
  );
}

const Memoized = memo(TelegramPreview);

export { Memoized as TelegramPreview };
